import helpers from './helpers';

let analytics = {
	spentOnPage15sec: () => {
		clearTimeout(helpers.$window.data('timeout15Sec'));

		helpers.$window.data('timeout15Sec', setTimeout(() => {
			ga('send', 'event', 'page', 'spent_on_page_15_sec');
		}, 15000));
	},
	virtualHit: (path) => {
		path = path.replace(window.location.origin, '');

		if (window.ga) {
			ga('set', 'page', path);
			ga('send', 'pageview', path);
		}

		if (window.yaCounter69999352) {
			yaCounter69999352.hit(path);
		}
	}
}

helpers.$document.find('[data-router-link]').on('click', (e) => {
	let href = e.currentTarget.href;

	analytics.virtualHit(href);
});

export default analytics;
